var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.504,
    height: 29.602,
    viewBox: "0 0 23.504 29.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel",
    transform: "translate(-1.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9793",
    "data-name": "Path 9793",
    d: "M76.239,26.959A2.646,2.646,0,0,1,73.591,29.6H55.383a2.646,2.646,0,0,1-2.648-2.643V2.643A2.646,2.646,0,0,1,55.383,0H66.718a1.988,1.988,0,0,1,1.406.582l7.535,7.536a1.98,1.98,0,0,1,.58,1.4Z",
    transform: "translate(-51.455 0)",
    fill: "#50d388"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9796",
    "data-name": "Path 9796",
    d: "M317.357,11.62h-6.729a1.791,1.791,0,0,1-1.79-1.791V3.1a1.967,1.967,0,0,1,.582.4l7.535,7.536a1.967,1.967,0,0,1,.4.581Z",
    transform: "translate(-292.751 -2.922)",
    fill: "#87e1ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13779",
    "data-name": "Path 13779",
    d: "M17.62,17.093H4.718a.65.65,0,0,1-.65-.65V8.65A.65.65,0,0,1,4.718,8h12.9a.65.65,0,0,1,.65.65v7.794A.65.65,0,0,1,17.62,17.093Zm-12.252-1.3h11.6V9.3H5.368Z",
    transform: "translate(1.749 6.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13780",
    "data-name": "Path 13780",
    d: "M9.65,17.093c-.359,0-.65-.157-.65-.35V8.35c0-.193.291-.35.65-.35s.65.157.65.35v8.394C10.3,16.937,10.008,17.093,9.65,17.093Z",
    transform: "translate(1.924 6.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13781",
    "data-name": "Path 13781",
    d: "M18.643,12.3H5.558a.657.657,0,0,1,0-1.3H18.643a.657.657,0,0,1,0,1.3Z",
    transform: "translate(0.817 7.387)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.f9a12401eeb8863da210536697a9c4bd.svg";
export { ForwardRef as ReactComponent };